export default __webpack_public_path__ + "static/media/TRUCK5.a61f1993.jpg";